import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { NativeLink } from './NativeLink'

export type LinkProps = {
  useNative?: boolean
  disabled?: boolean
} & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>

/**
 * This can be a wrapper for the the Link for react-router, or nextjs or even the native links
 * @param props
 * @constructor
 */
export const Link = (props: LinkProps) => {
  const useNative = props.useNative ?? true

  if (useNative) {
    return <NativeLink {...props} />
  }

  const { href, disabled: _disabled, useNative: _useNative, ...rest } = props
  return <RouterLink {...rest} to={href ?? '#'} />
}
